import React from 'react';

const PolicySection = ({ title, children, id }) => {
  return (
    <section id={id} className="mb-12">
      <h2 className="text-2xl font-jakarta font-semibold text-text-primary mb-6 border-b border-border pb-3">
        {title}
      </h2>
      <div className="prose prose-slate max-w-none">
        {children}
      </div>
    </section>
  );
};

export default PolicySection;